import React from 'react'
import parse from 'html-react-parser'

export default function ParagaphsParser( {paragraphs} ) {
  return (
    <div>
      { paragraphs?.map (
        ({tag, content, attr}) => (
            React.createElement(tag, attr, parse(content))
        )
      )}
    </div>
  )
}
